import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-slate-200 pt-16 pb-8 relative z-20" aria-label="Footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-xl font-bold text-slate-900 mb-4">XCape</h3>
            <p className="text-slate-600 text-sm leading-relaxed">
              Solusi privasi lokasi terdepan untuk profesional modern. Amankan kehadiran Anda, dimanapun Anda berada.
            </p>
          </div>
          
          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4">Produk</h4>
            <ul className="space-y-3">
              <li><Link to="/cara-kerja" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Cara Kerja</Link></li>
              <li><Link to="/aplikasi-didukung" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Aplikasi Didukung</Link></li>
              <li><Link to="/teknologi" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Teknologi Kalibrasi</Link></li>
              <li><Link to="/harga" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Harga</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4">Legal & Support</h4>
            <ul className="space-y-3">
              <li><Link to="/privasi" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Kebijakan Privasi</Link></li>
              <li><Link to="/syarat" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Syarat & Ketentuan</Link></li>
              <li><Link to="/hubungi-kami" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">Hubungi Kami</Link></li>
              <li><Link to="/faq" className="text-slate-600 hover:text-brand-primary transition-colors text-sm">FAQ</Link></li>
            </ul>
          </div>

           <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wider mb-4">Untuk Bisnis</h4>
            <ul className="space-y-3 mb-6">
              <li><Link to="/konsultasi" className="text-brand-primary font-bold hover:text-orange-700 transition-colors text-sm flex items-center gap-2">Developer / Enterprise SDK <span className="text-[10px] bg-slate-900 text-white px-1.5 py-0.5 rounded">B2B</span></Link></li>
            </ul>
            <p className="text-brand-primary font-mono text-sm mb-2 font-bold">Peluncuran: 22 Des 2025</p>
            <p className="text-slate-600 text-xs">Jadilah yang pertama mencoba teknologi presisi generasi baru.</p>
          </div>
        </div>
        
        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">© 2024 XCape Technology. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            {/* Social icons placeholders */}
            <button aria-label="Ikuti kami di Facebook" className="w-5 h-5 bg-slate-200 rounded-full hover:bg-brand-primary transition-colors cursor-pointer"></button>
            <button aria-label="Ikuti kami di Twitter" className="w-5 h-5 bg-slate-200 rounded-full hover:bg-brand-primary transition-colors cursor-pointer"></button>
            <button aria-label="Ikuti kami di Instagram" className="w-5 h-5 bg-slate-200 rounded-full hover:bg-brand-primary transition-colors cursor-pointer"></button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;